
import React from 'react';
import { Filter, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';

interface FilterToggleProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  hasActiveFilters: boolean;
  filtersCount: number;
  onClearFilters: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

export const FilterToggle: React.FC<FilterToggleProps> = ({
  isOpen,
  setIsOpen,
  hasActiveFilters,
  filtersCount,
  onClearFilters,
  children
}) => {
  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <div className="flex items-center justify-between">
        <CollapsibleTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2" type="button">
            <Filter className="h-4 w-4" />
            <span>Filters</span>
            {hasActiveFilters && (
              <span className="ml-1 rounded-full bg-primary w-5 h-5 text-primary-foreground text-xs flex items-center justify-center">
                {filtersCount}
              </span>
            )}
          </Button>
        </CollapsibleTrigger>
        
        {hasActiveFilters && (
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClearFilters} 
            className="gap-1"
            type="button"
          >
            <X className="h-3 w-3" />
            <span>Clear</span>
          </Button>
        )}
      </div>
      
      <CollapsibleContent className="pt-4 space-y-4">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};
